// Resolve API origin for both dev and production.
// Priority:
// 1) VITE_API_BASE_URL (if set at build time)
// 2) Browser current origin (same-origin deployments behind Nginx)
// 3) Localhost fallback (only for non-browser contexts)

export function getApiOrigin() {
  const envBase = import.meta.env?.VITE_API_BASE_URL;

  if (typeof envBase === "string" && envBase.trim()) {
    return envBase.replace(/\/+$/, "");
  }

  // In Vite dev, prefer SAME-ORIGIN and let Vite proxy `/api` to the backend.
  // This enables HTTPS dev without browser mixed-content blocking.
  try {
    if (import.meta.env?.DEV && typeof window !== "undefined" && window.location?.origin) {
      return window.location.origin;
    }
  } catch (e) {
    // ignore
  }

  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }

  return "http://localhost:3000";
}

export function getApiBaseUrl() {
  return `${getApiOrigin()}/api`;
}
